import React from 'react';
import '../Cards.css';
import CardItem from '../CardItem';

function SilverLion() {
    window.scrollTo(0, 0)
    return (
        <div>
            <div id='about' className='cards'>
                <h1>Silver Lion</h1>
                <h3 className="cards-description">Built for the Amazon Web Services Hackathon 2020, Silver Lion is Singapore’s first social health app. It aims to jointly improve the mental and physical health of senior citizens during lockdown. Our app allows senior citizens to join targeted fitness sessions on video call with their friends, re-building a sense of community and improving their physical health. Furthermore, we invited trainers who used to host frequent Tai Chi and Qi Gong sessions to teach workout classes, allowing senior citizens to be taught by familiar teachers, who understand the problems seniors face and are able to prescribe optimal exercises. We also heard that seniors often had health scares due to fake news circulated on Whatsapp, so we built a feature that fact-checks information.
                    <br></br>
                    <br></br>
                    <a style={{ textDecoration: "none;", color: "green", hover: "red" }} target="_blank" href="https://drive.google.com/drive/folders/1V0se3ZyEPmTfIf5GPuhLrk3vVW6cbuBS?usp=sharing">App screenshots</a>
                </h3>
            </div>

        </div>
    )
}

export default SilverLion
